<ngx-loading [show]="loading && !parentLoading"></ngx-loading>
<div>
  <button class="btn medium em-btn em-btn-green m-2" type="button" [disabled]="readOnly" (click)="addStyleClick()">
    <i class="fal fa-plus-circle"></i> Add
  </button>
  <button
    class="btn medium em-btn em-btn-green m-2"
    type="button"
    [disabled]="addingImage || selectedIndex === null || readOnly"
    (click)="removeStyleClick()"
  >
    <i class="fal fa-trash"></i> Remove
  </button>
</div>
<ng-scrollbar class="flex-1">
  <div *ngIf="addingImage" class="border border-radius align-self-center my-2">
    <canvas #canvas></canvas>
    <div class="d-flex justify-content-end py-2">
      <button class="btn medium em-btn em-btn-green mr-2" type="button" (click)="onSave()">
        <i class="far fa-save"></i> Save
      </button>
      <button class="btn medium em-btn em-btn-green mr-2" type="button" (click)="onCancel()">
        <i class="far fa-minus-circle"></i> Cancel
      </button>
    </div>
  </div>
  <ng-container *ngIf="!addingImage">
    <ng-container *ngIf="styles?.length; else noImages">
      <div *ngIf="styles[selectedIndex]" class="d-flex justify-content-center align-items-center my-2">
        <i *ngIf="styles.length > 1" class="fal fa-arrow-circle-left carousel-arrow mr-3" (click)="previousStyle()"></i>
        <img [src]="styles[selectedIndex].imageBlobUrl" alt="Gift Card Image" class="gc-image" />
        <i *ngIf="styles.length > 1" class="fal fa-arrow-circle-right carousel-arrow ml-3" (click)="nextStyle()"></i>
      </div>
      <div *ngIf="styles?.length" class="d-flex m-auto thumbnail-carousel">
        <div class="carousel-overlay"></div>
        <div class="thumbnail-scroll">
          <div class="thumbnail-images">
            <img
              #thumbImg
              *ngFor="let style of styles; let i = index"
              [src]="style.thumbnailBlobUrl"
              (click)="selectStyle(i)"
              alt="Gift Card Thumbnail"
              class="thumbnail"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noImages>
    <div class="flex-1 d-flex justify-content-center align-items-center">No Gift Card Styles</div>
  </ng-template>
</ng-scrollbar>
